var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconperformance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "sidemenuFillIcon",
    width: 22,
    height: 23,
    viewBox: "0 0 318.996 318.996",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M318.996,298.548c0,6.6-1.746,12-9.996,12H15c-8.25,0-15-6.75-15-15V18.446c0-8.25,5.4-9.998,12-9.998             s12,1.748,12,9.998v253.103c0,8.25,6.75,15,15,15h270C317.25,286.548,318.996,291.949,318.996,298.548z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M290.949,111.148c3.469,2.18,6.004,0.625,5.633-3.455l-5.801-63.897c-0.371-4.08-3.813-6.243-7.65-4.807             l-60.088,22.492c-3.836,1.437-4.139,4.395-0.67,6.575l11.141,7c3.469,2.18,4.465,6.763,2.211,10.185l-45.412,68.975             c-2.252,3.422-7.23,5.034-11.063,3.583l-70.58-26.725c-3.832-1.451-9.102-0.053-11.711,3.105l-44.324,53.66             c-2.609,3.159-4.762,9.095-4.783,13.191l-0.227,43.824c-0.02,4.097,2.146,4.905,4.814,1.797l57.084-66.487             c2.67-3.108,7.988-4.464,11.818-3.012l71.104,26.946c3.83,1.452,8.822-0.15,11.094-3.56l63.641-95.534             c2.271-3.41,6.967-4.415,10.436-2.236L290.949,111.148z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconperformance);
export default __webpack_public_path__ + "static/media/Iconperformance.305f9cb0e250452d1f57f457ead158e0.svg";
export { ForwardRef as ReactComponent };